import type {
  GetComponentStyle,
} from '@vtaits/react-paginator';

export const breakStyle: GetComponentStyle<unknown> = (
  baseStyle,
  {
    theme: {
      colors,
      fonts,
    },
  },
) => ({
  ...fonts.CAPTION,
  display: 'inline-block',
  verticalAlign: 'bottom',
  padding: 8,
  userSelect: 'none',
  color: colors.NEUTRAL_DEFAULT,
});
